'use client'

import { Component, type ReactNode } from 'react'
import { reportBrowserError } from '@/lib/observability/datadog-rum'

/** Optional panels cannot replace the workspace when their chunk fails to load. */
export class DeferredPanelBoundary extends Component<
  { children: ReactNode; fallback: ReactNode; panelName: string },
  { failed: boolean }
> {
  state = { failed: false }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  componentDidCatch(error: unknown) {
    reportBrowserError(error, {
      source: 'deferred_panel',
      panel: this.props.panelName,
    })
  }

  render() {
    return this.state.failed ? this.props.fallback : this.props.children
  }
}
